/* eslint-disable */
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols
// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.
import { createFileRoute } from '@tanstack/react-router';
import { Route as rootRouteImport } from './routes/__root.js';
import { Route as SucheRouteImport } from './routes/suche.js';
import { Route as IndexRouteImport } from './routes/index.js';
import { Route as SearchPsychotherapistsInChar123CityslugChar125RouteImport } from './routes/search/psychotherapists-in-{-$cityslug}.js';
import { Route as TherapistImportedRouteRouteImport } from './routes/therapist/imported/route.js';
import { Route as ClientRegisterClientRegisterRouteRouteImport } from './routes/client/register/ClientRegisterRoute.js';
import { Route as ClientAccountIndexRouteImport } from './routes/client/account/index.js';
import { Route as PsychotherapieUserIdCustomerIdRouteImport } from './routes/psychotherapie/$userId.$customerId.js';
import { Route as ProfileCustomerIdUserIdRouteImport } from './routes/profile/$customerId.$userId.js';
import { Route as ClientAccountInvoiceClientAccountInvoiceRouteRouteImport } from './routes/client/account/invoice/ClientAccountInvoiceRoute.js';
import { Route as ClientAccountDocumentClientAccountDocumentRouteRouteImport } from './routes/client/account/document/ClientAccountDocumentRoute.js';
import { Route as ClientAccountDeleteClientAccountDeleteRouteRouteImport } from './routes/client/account/delete/ClientAccountDeleteRoute.js';
import { Route as ClientAccountChangePasswordClientAccountChangePasswordRouteRouteImport } from './routes/client/account/change-password/ClientAccountChangePasswordRoute.js';
import { Route as ClientInvoiceDownloadTokenClientInvoiceDownloadTokenRouteRouteImport } from './routes/client/invoice/download/$token/ClientInvoiceDownloadTokenRoute.js';
const LoginLoginRouteLazyRouteImport = createFileRoute('/login')();
const DevDesignsystemDesignSystemRouteLazyRouteImport = createFileRoute('/dev/designsystem')();
const ClientAccountClientAccountRouteLazyRouteImport = createFileRoute('/client/account')();
const ProfileCustomerIdUserIdSplatLazyRouteImport = createFileRoute('/profile/$customerId/$userId/$')();
const AppointmentWidgetUserIdCustomerIdLazyRouteImport = createFileRoute('/appointment/widget/$userId/$customerId')();
const LoginLoginRouteLazyRoute = LoginLoginRouteLazyRouteImport.update({
    id: '/login',
    path: '/login',
    getParentRoute: () => rootRouteImport,
}).lazy(() => import('./routes/login/LoginRoute.lazy.js').then((d) => d.Route));
const SucheRoute = SucheRouteImport.update({
    id: '/suche',
    path: '/suche',
    getParentRoute: () => rootRouteImport,
});
const IndexRoute = IndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => rootRouteImport,
});
const DevDesignsystemDesignSystemRouteLazyRoute = DevDesignsystemDesignSystemRouteLazyRouteImport.update({
    id: '/dev/designsystem',
    path: '/dev/designsystem',
    getParentRoute: () => rootRouteImport,
}).lazy(() => import('./routes/dev/designsystem/DesignSystemRoute.lazy.js').then((d) => d.Route));
const ClientAccountClientAccountRouteLazyRoute = ClientAccountClientAccountRouteLazyRouteImport.update({
    id: '/client/account',
    path: '/client/account',
    getParentRoute: () => rootRouteImport,
}).lazy(() => import('./routes/client/account/ClientAccountRoute.lazy.js').then((d) => d.Route));
const SearchPsychotherapistsInChar123CityslugChar125Route = SearchPsychotherapistsInChar123CityslugChar125RouteImport.update({
    id: '/search/psychotherapists-in-{-$cityslug}',
    path: '/search/psychotherapists-in-{-$cityslug}',
    getParentRoute: () => rootRouteImport,
}).lazy(() => import('./routes/search/psychotherapists-in-{-$cityslug}.lazy.js').then((d) => d.Route));
const TherapistImportedRouteRoute = TherapistImportedRouteRouteImport.update({
    id: '/therapist/imported',
    path: '/therapist/imported',
    getParentRoute: () => rootRouteImport,
}).lazy(() => import('./routes/therapist/imported/route.lazy.js').then((d) => d.Route));
const ClientRegisterClientRegisterRouteRoute = ClientRegisterClientRegisterRouteRouteImport.update({
    id: '/client/register',
    path: '/client/register',
    getParentRoute: () => rootRouteImport,
}).lazy(() => import('./routes/client/register/ClientRegisterRoute.lazy.js').then((d) => d.Route));
const ClientAccountIndexRoute = ClientAccountIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ClientAccountClientAccountRouteLazyRoute,
});
const PsychotherapieUserIdCustomerIdRoute = PsychotherapieUserIdCustomerIdRouteImport.update({
    id: '/psychotherapie/$userId/$customerId',
    path: '/psychotherapie/$userId/$customerId',
    getParentRoute: () => rootRouteImport,
});
const ProfileCustomerIdUserIdRoute = ProfileCustomerIdUserIdRouteImport.update({
    id: '/profile/$customerId/$userId',
    path: '/profile/$customerId/$userId',
    getParentRoute: () => rootRouteImport,
});
const ClientAccountInvoiceClientAccountInvoiceRouteRoute = ClientAccountInvoiceClientAccountInvoiceRouteRouteImport.update({
    id: '/invoice',
    path: '/invoice',
    getParentRoute: () => ClientAccountClientAccountRouteLazyRoute,
}).lazy(() => import('./routes/client/account/invoice/ClientAccountInvoiceRoute.lazy.js').then((d) => d.Route));
const ClientAccountDocumentClientAccountDocumentRouteRoute = ClientAccountDocumentClientAccountDocumentRouteRouteImport.update({
    id: '/document',
    path: '/document',
    getParentRoute: () => ClientAccountClientAccountRouteLazyRoute,
}).lazy(() => import('./routes/client/account/document/ClientAccountDocumentRoute.lazy.js').then((d) => d.Route));
const ClientAccountDeleteClientAccountDeleteRouteRoute = ClientAccountDeleteClientAccountDeleteRouteRouteImport.update({
    id: '/delete',
    path: '/delete',
    getParentRoute: () => ClientAccountClientAccountRouteLazyRoute,
}).lazy(() => import('./routes/client/account/delete/ClientAccountDeleteRoute.lazy.js').then((d) => d.Route));
const ClientAccountChangePasswordClientAccountChangePasswordRouteRoute = ClientAccountChangePasswordClientAccountChangePasswordRouteRouteImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => ClientAccountClientAccountRouteLazyRoute,
}).lazy(() => import('./routes/client/account/change-password/ClientAccountChangePasswordRoute.lazy.js').then((d) => d.Route));
const ProfileCustomerIdUserIdSplatLazyRoute = ProfileCustomerIdUserIdSplatLazyRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => ProfileCustomerIdUserIdRoute,
}).lazy(() => import('./routes/profile/$customerId.$userId.$.lazy.js').then((d) => d.Route));
const AppointmentWidgetUserIdCustomerIdLazyRoute = AppointmentWidgetUserIdCustomerIdLazyRouteImport.update({
    id: '/appointment/widget/$userId/$customerId',
    path: '/appointment/widget/$userId/$customerId',
    getParentRoute: () => rootRouteImport,
}).lazy(() => import('./routes/appointment/widget/$userId.$customerId.lazy.js').then((d) => d.Route));
const ClientInvoiceDownloadTokenClientInvoiceDownloadTokenRouteRoute = ClientInvoiceDownloadTokenClientInvoiceDownloadTokenRouteRouteImport.update({
    id: '/client/invoice/download/$token',
    path: '/client/invoice/download/$token',
    getParentRoute: () => rootRouteImport,
}).lazy(() => import('./routes/client/invoice/download/$token/ClientInvoiceDownloadTokenRoute.lazy.js').then((d) => d.Route));
const ClientAccountClientAccountRouteLazyRouteChildren = {
    ClientAccountChangePasswordClientAccountChangePasswordRouteRoute: ClientAccountChangePasswordClientAccountChangePasswordRouteRoute,
    ClientAccountDeleteClientAccountDeleteRouteRoute: ClientAccountDeleteClientAccountDeleteRouteRoute,
    ClientAccountDocumentClientAccountDocumentRouteRoute: ClientAccountDocumentClientAccountDocumentRouteRoute,
    ClientAccountInvoiceClientAccountInvoiceRouteRoute: ClientAccountInvoiceClientAccountInvoiceRouteRoute,
    ClientAccountIndexRoute: ClientAccountIndexRoute,
};
const ClientAccountClientAccountRouteLazyRouteWithChildren = ClientAccountClientAccountRouteLazyRoute._addFileChildren(ClientAccountClientAccountRouteLazyRouteChildren);
const ProfileCustomerIdUserIdRouteChildren = {
    ProfileCustomerIdUserIdSplatLazyRoute: ProfileCustomerIdUserIdSplatLazyRoute,
};
const ProfileCustomerIdUserIdRouteWithChildren = ProfileCustomerIdUserIdRoute._addFileChildren(ProfileCustomerIdUserIdRouteChildren);
const rootRouteChildren = {
    IndexRoute: IndexRoute,
    SucheRoute: SucheRoute,
    LoginLoginRouteLazyRoute: LoginLoginRouteLazyRoute,
    ClientRegisterClientRegisterRouteRoute: ClientRegisterClientRegisterRouteRoute,
    TherapistImportedRouteRoute: TherapistImportedRouteRoute,
    SearchPsychotherapistsInChar123CityslugChar125Route: SearchPsychotherapistsInChar123CityslugChar125Route,
    ClientAccountClientAccountRouteLazyRoute: ClientAccountClientAccountRouteLazyRouteWithChildren,
    DevDesignsystemDesignSystemRouteLazyRoute: DevDesignsystemDesignSystemRouteLazyRoute,
    ProfileCustomerIdUserIdRoute: ProfileCustomerIdUserIdRouteWithChildren,
    PsychotherapieUserIdCustomerIdRoute: PsychotherapieUserIdCustomerIdRoute,
    ClientInvoiceDownloadTokenClientInvoiceDownloadTokenRouteRoute: ClientInvoiceDownloadTokenClientInvoiceDownloadTokenRouteRoute,
    AppointmentWidgetUserIdCustomerIdLazyRoute: AppointmentWidgetUserIdCustomerIdLazyRoute,
};
export const routeTree = rootRouteImport
    ._addFileChildren(rootRouteChildren)
    ._addFileTypes();
//# sourceMappingURL=routeTree.gen.js.map